import { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import content from "../../data/content";
import "./Navbar.css";

const { global: brand, navigation } = content;

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const [modalOpen, setModalOpen] = useState(false);
  const location = useLocation();
  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 50);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => {
    setMenuOpen(false);
    window.scrollTo(0, 0);
  }, [location.pathname]);

  // Allow other components to open the contact modal via custom event
  useEffect(() => {
    const open = () => setModalOpen(true);
    window.addEventListener("openContactModal", open);
    return () => window.removeEventListener("openContactModal", open);
  }, []);

  const handleLogoClick = (e) => {
    if (location.pathname === "/") {
      e.preventDefault();
      window.scrollTo({ top: 0, behavior: "smooth" });
    }
  };

  return (
    <>
      <nav className={`navbar ${scrolled ? "navbar--scrolled" : ""}`}>
        <div className="navbar__inner">
          <Link to="/" className="navbar__brand" onClick={handleLogoClick}>
            <img
              src={brand.logo}
              alt={brand.siteNameShort}
              className="navbar__logo"
            />
          </Link>

          <button
            className={`navbar__toggle ${menuOpen ? "navbar__toggle--open" : ""}`}
            onClick={() => setMenuOpen((prev) => !prev)}
            aria-label="Toggle menu"
          >
            <span />
            <span />
            <span />
          </button>

          <div className={`navbar__menu ${menuOpen ? "navbar__menu--open" : ""}`}>
            {navigation.links.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                className={`navbar__link ${
                  location.pathname === link.path ? "navbar__link--active" : ""
                }`}
              >
                {link.label}
              </Link>
            ))}
            <button
              className="navbar__cta"
              onClick={() => {
                setMenuOpen(false);
                setModalOpen(true);
              }}
            >
              {navigation.cta.label}
            </button>
          </div>
        </div>
      </nav>

      {modalOpen && (
        <ContactModal
          email={brand.email}
          onClose={() => setModalOpen(false)}
        />
      )}
    </>
  );
}

function ContactModal({ email, onClose }) {
  const [name, setName] = useState("");
  const [phone, setPhone] = useState("");
  const [subject, setSubject] = useState("");
  const [body, setBody] = useState("");

  const handleSubmit = (e) => {
    e.preventDefault();
    const mailSubject = encodeURIComponent(subject);
    const mailBody = encodeURIComponent(`姓名：${name}\n聯絡電話：${phone}\n\n${body}`);
    window.location.href = `mailto:${email}?subject=${mailSubject}&body=${mailBody}`;
    onClose();
  };

  const handleBackdrop = (e) => {
    if (e.target === e.currentTarget) onClose();
  };

  return (
    <div className="contact-modal__backdrop" onClick={handleBackdrop}>
      <div className="contact-modal">
        <button className="contact-modal__close" onClick={onClose}>
          &times;
        </button>
        <h2 className="contact-modal__title">預約諮詢</h2>
        <form className="contact-modal__form" onSubmit={handleSubmit}>
          <label className="contact-modal__label">
            姓名
            <input
              className="contact-modal__input"
              type="text"
              value={name}
              onChange={(e) => setName(e.target.value)}
              required
            />
          </label>
          <label className="contact-modal__label">
            聯絡電話
            <input
              className="contact-modal__input"
              type="tel"
              value={phone}
              onChange={(e) => setPhone(e.target.value)}
              required
            />
          </label>
          <label className="contact-modal__label">
            主旨
            <input
              className="contact-modal__input"
              type="text"
              value={subject}
              onChange={(e) => setSubject(e.target.value)}
              required
            />
          </label>
          <label className="contact-modal__label">
            內容
            <textarea
              className="contact-modal__textarea"
              value={body}
              onChange={(e) => setBody(e.target.value)}
              rows={5}
              required
            />
          </label>
          <button className="contact-modal__submit" type="submit">
            發送郵件
          </button>
        </form>
      </div>
    </div>
  );
}
